// 引入CryptoJS
import consoleLog from "@/utils/consoleLog";

const CryptoJS = require('crypto-js')


/**
 * @desc AES加密
 * @param {String} key - 加密的秘钥
 * @param {String} content - 需要加密的数据;
 */
const aesEncrypt = (key, content) => {
    // 将密钥转换成 WordArray 类型
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key)

    // ECB 模式不使用初始化向量 (IV)
    // 直接加密
    const encrypted = CryptoJS.AES.encrypt(content, keyUtf8, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })

    // 将加密后的数据转换为 Base64 字符串
    const encryptedBase64 = encrypted.toString()
    consoleLog.log('aesEncrypt:' + encryptedBase64)
    return encryptedBase64
}

/**
 * @desc AES解密;
 * @param {string} key - 加密使用的 key;
 * @param {string} content - 加密的数据;
 */
const aesDecrypt = (key, content) => {
    try {
        content = content.trim()
        if (content.length === 0) {
            return content
        }
        // 将密钥转换成 WordArray 类型
        const keyUtf8 = CryptoJS.enc.Utf8.parse(key)

        // 将待解密的数据从 Base64 解码为 WordArray
        const ciphertext = CryptoJS.enc.Base64.parse(content)

        // 解密
        const decrypted = CryptoJS.AES.decrypt(
            {ciphertext: ciphertext}, keyUtf8, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}
        )
        // 将解密后的数据转换为 Utf8 字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
        ///decryptedText 为空表示解析失败
        if (decryptedText.length === 0) {
            return content
        }
        return decryptedText
    } catch (e) {
        consoleLog.log('aesDecrypt解密失败:', e)
    }
    return content
}

export default {
    aesDecrypt,
    aesEncrypt
}
